const ja = {
	accountCenter: {
		myAccount: '出金口座',
		withdrawalAccounts: '合計：',
		withdrawalAccountsSub: '、 承認された：',
		pending: '審査中',
		fail: 'レビューに失敗しました',
		see: '確認',
		safeCenter: 'セキュリティセンター',
		password: 'ログインパスワード',
		phone: '登録済みの携帯電話',
		email: '登録済みのメールアドレス',
		keySetting: 'キー設定',
		changePassword: 'パスワード変更',
		changePhone: '電話番号の変更',
		bindEmail: '登録済みのメールアドレス',
		changeEmail: 'メールアドレスの変更',
		saltSetting: 'キー設定',
		setting: '設定',
		passwordDesc: 'パスワードが強力であればあるほど、アカウントのセキュリティ レベルが高くなり、不正利用される可能性が低くなります。',
		phoneDesc: 'セキュリティ認証は、収入口座を変更するためにお金を引き出すときに、携帯電話のSMS認証コードを送信することによって行われます。',
		emailDesc: 'ログインメールとして、パスワードの取得やその他の確認操作もこのメールにメールで送信されます。',
		saltDesc: '重要な情報を安易に漏洩させない'
	},
	password: {
		accountCenter: 'アカウントセンター',
		modifyLoginPassword: 'パスワード変更',
		oldPassword: '現在のパスワード',
		newPassword: '新しいパスワード',
		again: 'パスワード（確認用）',
		phoneCode: '携帯電話認証コード (SMS が送信されます)',
		comfirm: '確認する',
		oldpasswordMsg: '元のログインパスワードを入力してください',
		newPasswordMsg: '新しいログインパスワードを入力してください',
		newPasswordAgain: 'パスワードをもう一度入力してください',
		differPassword: 'パスワードが一致しません。',
		saftyCode: 'セキュリティ認証コードを入力してください',
		passwordSuccess: 'パスワードが正常に変更されました',
		codeOverTime: '認証コードのタイムアウト',
		codeError: '認証コードエラー',
		oldPasswordError: '元のパスワードが間違っています',
		unknownError: '不明なエラー、ログインパスワードの変更に失敗しました',
		tip: '注意: アカウントのセキュリティを確保するため、ログイン パスワードを 90 日ごとに変更してください。',
		usTip: 'アカウントのセキュリティを確保するために、ログイン パスワードを 90 日ごとに変更してください。パスワード変更後は、ピンポンの他の業務でも同時に変更されます。',
		passwordMsg: 'パスワードの強度: 弱い、パスワードには大文字、小文字、数字が含まれており、8 文字以上である必要があります。',
		numberLetters: 'パスワードは数字と文字の組み合わせである必要があり、スペースや特殊文字は含まれません。',
		incorrectPwd: 'パスワードがルールに準拠していません'
	},
	phone: {
		modifyBindPhone: '登録済み携帯電話番号の変更',
		newPhone: '新しい携帯電話番号',
		validateWay: '認証方法',
		phoneValidate: 'SMS認証',
		emailValidate: 'メール認証',
		oldPhoneCode: 'オリジナルの携帯電話認証コード (SMS メッセージが送信されます)',
		oldEmailCode: 'メール認証コード (認証コードは次のアドレスに送信されます)',
		tip: '注意: 携帯電話番号を変更すると、他の PingPong ビジネスでも同時に変更されます。',
		newPhoneMsg: '新しい携帯電話番号を入力してください',
		newPhoneCode: '新しいSMS認証コード',
		emailCode: 'メール認証コードを入力してください',
		emailSuccess: 'バインド電子メールが正常に変更されました',
		oldPhoneError: '元の携帯電話番号が間違っています',
		phoneRegister: '新しい携帯電話番号が登録されました',
		unknownError: '不明なエラー。バインドされた携帯電話番号を変更できませんでした。',
		phoneSuccess: '携帯電話番号のバインドが正常に変更されました'
	},
	email: {
		modifyBindEmail: 'メールアドレスの変更',
		newEmail: '新しいメールアドレス',
		newEmailCode: '新しいメール認証コード',
		phoneCode: '携帯電話認証コード (SMS が送信されます)',
		newEmailMsg: '新しいメールアドレスを入力してください',
		emailCode: '新しいメール認証コードを入力してください',
		phoneCodeMsg: '携帯電話の認証コードを入力してください',
		emailRegister: '新しいメールアドレスが登録されました',
		unknowmError: '不明なエラー。バインディング電子メール アドレスの変更に失敗しました。',
		tip: '注意: メール アドレスを変更すると、PingPong の他のビジネスでも同時に変更されます。'
	},
	salt: {
		saltSetting: 'キー管理',
		storeName: 'Webサイト',
		omniStoreName: '店舗 / ウェブサイト名',
		accId: 'WebサイトID',
		omniAccId: '店舗/ウェブサイトID',
		export: 'エクスポートキー',
		search: '検索',
		reset: 'リセット',
		type: '暗号化方式',
		apiStatus: 'APIステータス',
		updateTime: '更新日時',
		operation: '操作',
		saltDetail: '詳細',
		salt: '鍵',
		copy: 'コピー',
		freshenSalt: 'リフレッシュキー',
		freshenSaltTip: '注: キーがリセットされると、販売システムのリクエストは新しいキーを使用してシステムとの対話を完了する必要があります。慎重に進めてください。',
		freshenSuccess: '秘密キーが正常に更新されました',
		latestSalt: '最新のキー',
		timeOut: '認証コードのタイムアウト',
		codeError: '認証コードエラー',
		unknownError: '不明なエラー',
		cancel: 'キャンセル',
		normal: '正常',
		abnormal: '異常な'
	},
	tradeType: '取引タイプ',
	tradeTypeOptions: {
		Service: 'サービス貿易',
		Goods: '貨物貿易',
		Digital: 'バーチャルグッズ/サービス',
		ServiceGoods: 'サービスまたは商品'
	},
	identityVerificationApproved: '本人確認済'
}
export default ja
